import React from 'react';
import MaterialFormHelperText from '@mui/material/FormHelperText';
import type {FormHelperTextProps as MaterialFormHelperTextProps} from '@mui/material/FormHelperText';
import {styled} from '@mui/material/styles';

export type FormHelperTextProps = MaterialFormHelperTextProps;

const StyledFormHelperText = styled(MaterialFormHelperText)({
    margin: '3px 0 0'
});

export const FormHelperText = React.forwardRef<any, FormHelperTextProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <StyledFormHelperText
                ref={ref}
                {...props}
            >
                {children}
            </StyledFormHelperText>
        );
    });

FormHelperText.displayName = 'FormHelperText';
